module.exports = __webpack_public_path__ + "media/sakura.bb6865a7.mp4";